
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyMooringBarrel as ObiBuoyMooringBarrelElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-mooring-barrel.js';
 
 
 

 
 export const ObiBuoyMooringBarrel = createComponent({
   react: React,
   tagName: 'obi-buoy-mooring-barrel',
   elementClass: ObiBuoyMooringBarrelElement,
   events: {
     
   }
  });
 
 